module.exports = __webpack_public_path__ + "static/media/palafolls-blanc.5c0b3436.svg";